import { Component, Input } from '@angular/core';
import { PainterService } from "@shared/services/item-feed/image-feed/painter.service";
import { ColorMapContextService } from '@shared/services/color-map-context.service';
import { PredictionMLTask } from 'src/generated-sources';
import { DeephubDesignDataFetcherService } from '@features/deephub/computer-vision/design/services/deephub-design-data-fetcher.service';
import { ImageClassificationDataFormatterService } from '@shared/services/item-feed/image-feed/image-classification/image-classification-sample-data-formatter.service';
import { ImageClassificationPainterService } from '@shared/services/item-feed/image-feed/image-classification/image-classification-painter.service';
import { SampleDataFormatterService } from '@shared/services/item-feed/image-feed/sample-data-formatter.service';
import { SampleDataFetcherService } from '@shared/services/item-feed/image-feed/sample-data-fetcher.service';
import { ItemsDataFetcherService } from '@shared/services/item-feed/items-data-fetcher.service';
import { ImagesDataFetcherService } from '@shared/services/item-feed/image-feed/images-data-fetcher.service';

@Component({
    selector: 'deephub-image-classification-design-image-feed',
    templateUrl: './deephub-image-classification-design-image-feed.component.html',
    providers: [
        ColorMapContextService,
        DeephubDesignDataFetcherService,
        ImageClassificationDataFormatterService,
        ImageClassificationPainterService,
        { provide: SampleDataFormatterService, useExisting: ImageClassificationDataFormatterService},
        { provide: ItemsDataFetcherService, useExisting: DeephubDesignDataFetcherService },
        { provide: ImagesDataFetcherService, useExisting: DeephubDesignDataFetcherService },
        { provide: SampleDataFetcherService, useExisting: DeephubDesignDataFetcherService },
        { provide: PainterService, useExisting: ImageClassificationPainterService },
    ]
})
export class DeephubImageClassificationDesignImageFeedComponent {
    @Input() mltask: PredictionMLTask.DeepHubPredictionMLTask;
    @Input() selectedCategories?: string[];
    // Explicitly pass pathColumn and managedFolderSmartId to trigger change from Angular
    @Input() pathColumn: string;
    @Input() managedFolderSmartId: string;
};
